import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"

class ConfigHolidayService {
  public async getListWorkDay(params?): Promise<any> {
    const res = await http.get("/api/services/app/WorkSchedule/Get", {
      params,
    })
    const { result } = res.data

    return result
  }

  public async changeConfigWorkday(body: any): Promise<any> {
    const res = await http.put("api/services/app/WorkSchedule/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )

    return res.data
  }

  public async getAllHoliday(params?): Promise<PagedResultDto<any>> {
    const res = await http.get("/api/services/app/HolidayAndLeave/GetAll", {
      params,
    })

    return res.data.result
  }

  public async createOrUpdate(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/HolidayAndLeave/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )

    return res.data
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/HolidayAndLeave/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
}

export default new ConfigHolidayService()
